module.exports = __webpack_public_path__ + "img/twitter.2b18fb4b.svg";